export const buildInfo = {
  buildVersion: "2.1.4",
  buildDate: "2026-06-16T09:14:38+0000",
  buildNumber: ""
}
